'use strict';
// https://github.com/tc39/proposal-flatMap
require('../modules/es.array.flat');
require('../modules/es.array.flat-map');
require('../modules/es.array.unscopables.flat');
require('../modules/es.array.unscopables.flat-map');
